module.exports = __webpack_public_path__ + "src/assets/img/title_main_lastminutedeal.80c44a.png";